import { render } from "./leftBar.vue?vue&type=template&id=295eb65f"
import script from "./leftBar.vue?vue&type=script&lang=js"
export * from "./leftBar.vue?vue&type=script&lang=js"
script.render = render

export default script